import _ from 'lodash'
import Vue from 'vue'
import { assert } from 'chai'

export default {
  SET_ITEMS(state, payload) {
    assert.exists(payload.modelName, 'SET_ITEMS: payload.modelName must exists')
    assert.isArray(payload.items, 'SET_ITEMS: payload.items must be an array. Model name:' + payload.modelName)
    Vue.set(payload.state || state, payload.modelName, payload.items)
  },
  SET_ITEM(state, payload) {
    assert.exists(payload.modelName, 'SET_ITEM: payload.modelName must exists.')
    assert.exists(payload.item, 'SET_ITEM: payload.item must exists. Model name:' + payload.modelName)
    Vue.set(payload.state || state, payload.modelName, payload.item)
  },
  SET_COUNT(state, payload) {
    assert.exists(payload.totalModelName, 'SET_ITEM: payload.totalModelName must exists.')
    Vue.set(payload.state || state, payload.totalModelName, payload.totalCount || 0)
  },
  PERSIST_ITEM(state, payload) {
    assert.isArray(payload.addTo, 'PERSIST_ITEM: payload.addTo must be an array')
    assert.isObject(payload.item, 'PERSIST_ITEM: payload.item must be an object. AddTo: ' + JSON.stringify(payload.addTo))
    assert.exists(payload.item.id, 'PERSIST_ITEM: payload.item.id must exists. AddTo: ' + JSON.stringify(payload.addTo))

    const destinationState = payload.state || state
    const id = payload.item.id

    payload.addTo.forEach(model => {
      if (!_.isArray(destinationState[model])) return
      const index = destinationState[model].findIndex(object => {
        return object.id.toString() === id.toString()
      })
      if (index !== -1) destinationState[model].splice(index, 1, payload.item)
      else destinationState[model].push(payload.item)
    })
  },
  DELETE_ITEM(state, payload) {
    assert.isArray(payload.removeFrom, 'DELETE_ITEM: payload.removeFrom must be an array')
    if (payload.item) {
      assert.isObject(payload.item, 'DELETE_ITEM: payload.item must be an object. RemoveFrom: ' + JSON.stringify(payload.removeFrom))
      assert.exists(payload.item.id, 'DELETE_ITEM: payload.item.id must exists. RemoveFrom: ' + JSON.stringify(payload.removeFrom))
    } else {
      assert.exists(payload.id, 'DELETE_ITEM: payload.id must exists. RemoveFrom: ' + JSON.stringify(payload.removeFrom))
    }

    const idToDelete = payload.id || payload.item.id
    const destinationState = payload.state || state

    payload.removeFrom.forEach(model => {
      if (!_.isArray(destinationState[model])) return
      const index = destinationState[model].findIndex(object => {
        return object.id === idToDelete
      })
      if (index === -1) return
      destinationState[model].splice(index, 1)
    })
  }
}
